import masjed from '../static/img/masjed.png'
function PlayerContainerImage(){
return(
    <img src={masjed} alt='masjed' />
)
}
export default PlayerContainerImage